var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOutlineRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33382 9.33333V1.33333H12.0378L9.45782 4.94667C9.37743 5.05957 9.33423 5.19473 9.33423 5.33333C9.33423 5.47194 9.37743 5.60709 9.45782 5.72L12.0378 9.33333H1.33382ZM1.33382 10.6667H13.3338C13.4562 10.6666 13.5762 10.6328 13.6806 10.5691C13.7851 10.5054 13.87 10.4141 13.9261 10.3053C13.9821 10.1965 14.0071 10.0744 13.9984 9.95237C13.9896 9.83032 13.9475 9.71302 13.8765 9.61333L10.8192 5.33333L13.8765 1.05333C13.9475 0.953648 13.9896 0.836352 13.9984 0.714294C14.0071 0.592236 13.9821 0.470127 13.9261 0.361344C13.87 0.252562 13.7851 0.161303 13.6806 0.0975666C13.5762 0.0338303 13.4562 7.54217e-05 13.3338 0H0.667155C0.490344 0 0.320775 0.070238 0.195751 0.195262C0.0707263 0.320287 0.000488281 0.489856 0.000488281 0.666667V15.3333C0.000488281 15.5101 0.0707263 15.6797 0.195751 15.8047C0.320775 15.9298 0.490344 16 0.667155 16C0.843966 16 1.01354 15.9298 1.13856 15.8047C1.26358 15.6797 1.33382 15.5101 1.33382 15.3333V10.6667Z",
    fill: "#D00026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOutlineRed);
export default __webpack_public_path__ + "static/media/flag-outline-red.fcde6e4ad46ca097f3614bc280fc1c27.svg";
export { ForwardRef as ReactComponent };